import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import ContentBox from 'components/CncUI/ContentBox';
import Typography from 'components/CncUI/Typography';
import Button from 'components/CncUI/Button';
import Snackbar from 'components/CncUI/Snackbar';
import Link from 'components/CncUI/Link';
import PhoneEnrollmentCard from '../PhoneEnrollmentCard';

import TextMessageImage from 'images/createAccount/TextMessage.svg';
import CallImage from 'images/createAccount/VoiceCall.svg';
import OktaImage from 'images/createAccount/OktaLogo.png';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  root: {
    width: 474,
    margin: '50px auto',
    padding: '48px 69px 69px',
    [breakpoints.down('sm')]: {
      width: '100%',
      marginTop: 0,
      padding: '37px 0 56px 0',
    },
    '& .cncui-snackbar': {
      marginTop: 16,
      '& .cncui-snackbar-alert': {
        width: 453,
        height: 40,
      },
    },
  },
  spaceTop: {
    marginTop: 20,
  },
  lessSpaceTop: {
    marginTop: 12,
  },
  phone: {
    fontSize: 18,
    lineHeight: '21.09px',
  },
  muiLink: {
    marginBottom: 50,
  },
  email: {
    background: palette.cncUI.default.table,
    borderRadius: 2,
    textAlign: 'center',
    borderBottom: `1px solid ${palette.cncUI.default['+8']}`,
    height: 54,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const AccountCreated = props => {
  const classes = useStyles();
  const [alert, setAlert] = useState({ message: '', show: false });
  const { setStep, state } = props;
  const { tokenData } = state;
  const uri = encodeURIComponent(tokenData.user && tokenData.user.email);
  const fromUri = encodeURIComponent(state.fromURI);
  const loginUrl = `/login?login=${uri}&fromURI=${fromUri}&hide=register`;
  const phoneMasked =
    state &&
    state.phone &&
    `(xxx) xxx - ${state.phone.substr(state.phone.length - 4)}`;

  const notify = data => setAlert(old => ({ ...old, ...data }));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.onbeforeunload = function() {};
    switch (state.adding) {
      case 'sms':
        notify({ message: 'Text message added', show: true });
        break;
      case 'okta':
        notify({ message: 'Okta verify added', show: true });
        break;
      case 'call':
        notify({ message: 'Voice added', show: true });
        break;
      default:
        break;
    }
  }, [state.adding]);

  return (
    <ContentBox className={classes.root} id="AccountCreatedRoot">
      <Snackbar
        title={alert.message}
        open={alert.show}
        onClose={() => notify({ show: false })}
        position="top-center"
        hideDuration={4500}
        inline
        variant="success"
      />
      <Grid container spacing={2} direction="column" alignItems="center">
        <Grid item xs={12}>
          <Typography variant="h3">Your account is activated</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" size="short" align="center">
            Your phone number below is now enrolled in these Multi-Factor
            Authentication password recovery methods:
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.phone}>{phoneMasked}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1} alignItems="center" direction="column">
            {state && state.sms && (
              <Grid item xs={12}>
                <PhoneEnrollmentCard
                  image={TextMessageImage}
                  title="Text Message"
                  id="AccountCreatedTextCard"
                  dataTestId="AccountCreated-text-card"
                />
              </Grid>
            )}
            {state && state.call && (
              <Grid item xs={12}>
                <PhoneEnrollmentCard
                  image={CallImage}
                  title="Voice"
                  id="AccountCreatedVoiceCard"
                  dataTestId="AccountCreated-voice-card"
                />
              </Grid>
            )}
            {state && state.okta && (
              <Grid item xs={12}>
                <PhoneEnrollmentCard
                  image={OktaImage}
                  title="Okta Verify"
                  variant="okta"
                  justAdded={state.adding === 'okta'}
                  id="AccountCreatedOktaCard"
                  dataTestId="AccountCreated-okta-card"
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        {(!state.call || !state.sms || !state.okta) && (
          <Grid item xs={12}>
            <Typography variant="body2" className={classes.lessSpaceTop}>
              <Link
                id="AccountCreatedAddLink"
                className={classes.muiLink}
                onClick={() => setStep('AdditionalAuthentication')}
              >
                Add another (optional method)
              </Link>
            </Typography>
          </Grid>
        )}
        <Grid item xs={12} className={classes.spaceTop}>
          <Typography variant="h5" align="center" style={{ maxWidth: 320 }}>
            Your account is linked to this email address. Please make note of
            it.
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ width: '100%' }}>
          <div className={classes.email}>
            <Typography variant="body2" size="short">
              {tokenData.user && tokenData.user.email}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} style={{ width: '100%', marginTop: 48 }}>
          <Button fullWidth id="AccountCreatedLoginButton" href={loginUrl}>
            Log in to MyCast&Crew
          </Button>
        </Grid>
      </Grid>
    </ContentBox>
  );
};

export default AccountCreated;
